import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Diagnostico } from './Diagnostico.entity';
import { Router } from '@angular/router';
import { NavegacionService } from '../sidenav.service';

@Component({
  selector: 'app-diagnostico',
  templateUrl: './diagnostico.component.html',
  styleUrls: ['./diagnostico.component.css'] // , '../../assets/scss/tool-styles.scss']
})
export class DiagnosticoComponent implements OnInit {

  constructor(private _sidenav: NavegacionService ) { }

  ngOnInit() {
     // this._sidenav.open();
     // this._sidenav.recursos(true);
  }
  Iniciar() {
    // this._sidenav.toggle();
    // console.log('Pase por iniciar diagnostico.');
    // this._sidenav.Iniciar();
    this._sidenav.Iniciar();
  }
}



// WEBPACK FOOTER //
// ./src/app/diagnostico/diagnostico.component.ts